// extracted by mini-css-extract-plugin
export default {"addReportButton":"ReportPage_addReportButton__ZkjUm"};